import { motion } from "motion/react";
import { FC } from "react";
import NavigationItem, { NavigationItemProps } from "./navbar-item";

const menuItems: NavigationItemProps[] = [
  {
    label: "Indicadores Generales",
    href: `general`,
  },
  {
    label: "Dimensión Gobernanza",
    href: `GOVERNANCE`,
  },
  {
    label: "Dimensión Modelo de Negocio e Innovación",
    href: `BUSINESS_MODEL_AND_INNOVATION`,
  },
  {
    label: "Dimensión Ambiental",
    href: `ENVIRONMENTAL`,
  },
  {
    label: "Dimensión Social",
    href: `SOCIAL`,
  },
];

const Navbar: FC = () => {
  return (
    <motion.nav
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="flex items-center justify-center gap-2 rounded-full bg-white px-1 py-4"
    >
      {menuItems.map((item) => (
        <NavigationItem key={item.label} label={item.label} href={item.href} />
      ))}
    </motion.nav>
  );
};

export default Navbar;
